<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { textAboveBackground } = $AppState.theme.colors;

  export let color: string = textAboveBackground;
</script>

<svg
  style={$$props.style}
  width="24"
  height="14"
  viewBox="0 0 24 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2 2L12 12L22 2"
    stroke={color}
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
